import {
  collection, doc, getDocs, setDoc, deleteDoc, updateDoc,
  query, orderBy, Timestamp,
} from 'firebase/firestore';
import { db } from '../firebase';

import { C_CAMPAIGNS } from '../../constants/collections';
export interface Campaign {
  id: string;
  storyId?: string; // links back to source story for feed filtering
  storyTitle: string;
  storySource: string;
  storySummary: string;
  angle: string;
  angleType: string; // 'ai1', 'ai2', 'custom'
  outputs: Record<string, string>; // podcast, social, etc.
  igSlides: { title: string; body: string }[];
  createdAt: string; // ISO string
  status: 'draft' | 'sent' | 'published';
}

const campaignsCol = () => collection(db, C_CAMPAIGNS);

function stripUndefined(obj: unknown): unknown {
  if (obj === null || obj === undefined || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) return obj.map(stripUndefined);
  const cleaned: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(obj as Record<string, unknown>)) {
    if (value !== undefined) {
      cleaned[key] = (value !== null && typeof value === 'object') ? stripUndefined(value) : value;
    }
  }
  return cleaned;
}

export async function saveCampaign(campaign: Campaign): Promise<void> {
  await setDoc(doc(campaignsCol(), campaign.id), {
    ...(stripUndefined(campaign) as Record<string, unknown>),
    _createdAt: Timestamp.now(),
  });
}

export async function getAllCampaigns(): Promise<Campaign[]> {
  const snap = await getDocs(query(campaignsCol(), orderBy('_createdAt', 'desc')));
  return snap.docs.map((d) => d.data() as Campaign);
}

export async function updateCampaignStatus(id: string, status: Campaign['status']): Promise<void> {
  await updateDoc(doc(campaignsCol(), id), { status });
}

export async function deleteCampaign(id: string): Promise<void> {
  await deleteDoc(doc(campaignsCol(), id));
}
